import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/images/home/play-icon.png'
import _imports_1 from '@/assets/images/home/studio-mobile.jpg'
import _imports_2 from '@/assets/images/home/particles-moment.png'


const _hoisted_1 = { class: "header-video" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "core-advantages" }
const _hoisted_4 = { class: "core-scene" }
const _hoisted_5 = { class: "studio-video" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  style: {"background-color":"#fff"},
  class: "cost-base"
}
const _hoisted_8 = { class: "cost-wrap" }
const _hoisted_9 = { class: "easy-operate" }
const _hoisted_10 = { class: "easy-operate-image" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "arrange" }
const _hoisted_13 = { class: "arrange-icon" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "fusion" }
const _hoisted_16 = { class: "fusion-content" }
const _hoisted_17 = { class: "fusion-window" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "fusion-list-box" }
const _hoisted_20 = { class: "fusion-list-info" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "metaverse-title" }
const _hoisted_23 = { class: "metaverse-content" }
const _hoisted_24 = { class: "show-project" }
const _hoisted_25 = { class: "partner-wrap" }
const _hoisted_26 = { class: "bg-video" }
const _hoisted_27 = { class: "contact-us" }
const _hoisted_28 = { class: "form-wrap-m" }

import { ref, reactive, onMounted, watch, onUnmounted } from 'vue'
import { asynchronousRetrieval } from '@/utils'
import BannerView from '@/components/mobile/BannerView.vue';
import { addConsult } from '@/api'
import router from '@/router';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const loadUrl: any = ref({})
const costList = [['降低', '50%', '技术开发成本'], ['增加', '200%', '投资回报率'], ['节省', '80%', '部署时间'], ['综合提效', '300%', '创作落地']]
const arrangeList = [require('@/assets/images/home/list-icon.png'), require('@/assets/images/home/audio-bg-icon.png'), require('@/assets/images/home/service-bg-icon.png'), require('@/assets/images/home/blank-bg-icon.png'), require('@/assets/images/home/data-bg-icon.png'), require('@/assets/images/home/wifi-bg-icon.png'), require('@/assets/images/home/phone-bg-icon.png')]
const metaversePlatformList: any = ref(
  [
    {
      title: '文娱元宇宙',
      type: 1,
      content: '景区导览、遗迹重现、虚拟博物馆/文化馆/艺术馆、商业空间、IP展览、儿童游乐项目体验、企业展厅、营销互动、大型活动、虚拟数字人',
    },
    {
      title: '工业元宇宙',
      type: 2,
      content: '远程协助、数字孪生、点巡检、虚拟装配、维修维护、工厂漫游、技能培训、设计评审',
    },
    {
      title: '教育元宇宙',
      type: 3,
      content: '基础教育/高等教育/职业教育教学、播控、创新实验室建设、创新课堂建设、企业培训',
    }
  ]
)
const projectTypeList: any = ref(
  [
    {
      title: '微信小程序',
      type: 0,
      content: '高效创作XR/3D/数字人/虚拟展厅等元宇宙内容助力品牌/营销',
      frameNum: 198,
      key: 'wechat',
      diff: 7,
      imgs: [
        {
          url: loadUrl.value.wechat_gif,
          class: 'wechat-bg',
          size: [-276.5, -249]
        },
        {
          url: require('@/assets/images/home/wechat-icon.png'),
          class: 'wechat-icon',
          size: [-155, -157]
        },
        {
          url: require('@/assets/images/home/wechat-icon2.png'),
          class: 'wechat-icon2',
          size: [-46, 147]
        }
      ]
    },
    {
      title: 'VR端',
      type: 1,
      content: '高效创作XR/3D/数字人/虚拟展厅等元宇宙内容助力品牌/营销',
      frameNum: 108,
      key: 'VR',
      diff: 67,
      imgs: [
        {
          url: loadUrl.value.VR_gif,
          class: 'room-bg',
          size: [-276.5, -249]
        },
        {
          url: require('@/assets/images/home/rokid.png'),
          class: 'rokid',
          size: [-194, 39]
        }
      ]
    },
    {
      title: 'AR端',
      type: 2,
      content: '高效创作XR/3D/数字人/虚拟展厅等元宇宙内容助力品牌/营销',
      frameNum: 108,
      key: 'AR',
      diff: 0,
      imgs: [
        {
          url: loadUrl.value.AR_gif,
          class: 'ar-bg',
          size: [-276.5, -249]
        },
        {
          url: require('@/assets/images/home/ar-rokid.png'),
          class: 'ar-rokid',
          size: [-223, -6]
        }
      ]
    },
    {
      title: 'web端',
      type: 3,
      content: '高效创作XR/3D/数字人/虚拟展厅等元宇宙内容助力品牌/营销',
      frameNum: 108,
      key: 'web',
      diff: 5,
      imgs: [
        {
          url: loadUrl.value.web_gif,
          class: 'web-bg',
          size: [-276, -208]
        }
      ]
    },
  ]
)
const activeFusionIndex = ref(0)
const fusionVideo: any = ref([20.966667, 18.552993, 16.068005])
let timer: any = null;
const viewTime = ref(0)
const contactInfo: any = reactive({
  companyName: '',
  name: '',
  phone: '',
  industry: null
})
const industryList = [
  {
    name: '文娱',
    value: 1,
  },
  {
    name: '工业',
    value: 2,
  },
  {
    name: '教育',
    value: 3,
  },
  {
    name: '其他',
    value: 4,
  }
]
const showError = ref(false)
const checkEmpty: any = ref({})
const showStudioVideoPlay = ref(true) // 是否显示混空Studio视频的播放按钮

const playStudioVideoPlay = () => {
  const studioVideo: any = document.querySelector('.studio-video video');
  studioVideo.play();
  showStudioVideoPlay.value = false;
}

const playEvent = () => {
  showStudioVideoPlay.value = false;
}

const submitEvent = () => {
  let reg = /^(130|131|132|133|134|135|136|137|138|139|145|146|147|148|149|150|151|152|153|155|156|157|158|159|166|170|171|173|174|175|176|177|178|180|181|182|183|184|185|186|187|188|189|191|198|199)\d{8}$/
  Object.keys(contactInfo).forEach((k) => {
    checkEmpty.value[k] = !contactInfo[k]
  })
  if (!reg.test(contactInfo.phone.replace(/\s+/g, "")) || !contactInfo.phone) {
    showError.value = true;
    return
  } else if (!contactInfo.companyName || !contactInfo.name || !contactInfo.industry) {
    return
  }
  addConsult({ ...contactInfo }).then((res: any) => {
    contactInfo.companyName = ''
    contactInfo.name = ''
    contactInfo.phone = ''
    contactInfo.industry = null
    showError.value = false;
    checkEmpty.value = {}
  })
}

const openTimer = () => {
  clearInterval(timer)
  timer = setInterval(() => {
    viewTime.value += 1;
    if (viewTime.value > fusionVideo.value[activeFusionIndex.value]) {
      activeFusionIndex.value += 1;
      if (activeFusionIndex.value > 2) {
        activeFusionIndex.value = 0
      }
      viewTime.value = 1;
    }
  }, 1000)
}

onMounted(async () => {
  openTimer()
  const home_banner_mp4: any = await asynchronousRetrieval('webimg/video/home-banner.gif');
  const studio_mp4: any = await asynchronousRetrieval('webimg/video/studio-mobile.mp4');
  const entertainment_mp4: any = await asynchronousRetrieval('webimg/gif/entertainment.gif');
  const industry_mp4: any = await asynchronousRetrieval('webimg/gif/industry.gif');
  const education_mp4: any = await asynchronousRetrieval('webimg/gif/education.gif');
  const wechat_gif: any = await asynchronousRetrieval('webimg/gif/wechat.gif');
  const VR_gif: any = await asynchronousRetrieval('webimg/gif/VR.gif');
  const AR_gif: any = await asynchronousRetrieval('webimg/gif/AR.gif');
  const web_gif: any = await asynchronousRetrieval('webimg/gif/web.gif');
  const ycaozuo_gif: any = await asynchronousRetrieval('webimg/ycaozuo.gif');
  const partner3: any = await asynchronousRetrieval('webimg/images/home/partner3.png');
  const bg_mask: any = await asynchronousRetrieval('webimg/images/home/bg-mask.png');
  loadUrl.value = { home_banner_mp4, studio_mp4, entertainment_mp4, industry_mp4, education_mp4, wechat_gif, VR_gif, AR_gif, web_gif, ycaozuo_gif, partner3, bg_mask }

  metaversePlatformList.value[0].url = entertainment_mp4;
  metaversePlatformList.value[1].url = industry_mp4;
  metaversePlatformList.value[2].url = education_mp4;
  projectTypeList.value[0].imgs[0].url = wechat_gif;
  projectTypeList.value[1].imgs[0].url = VR_gif;
  projectTypeList.value[2].imgs[0].url = AR_gif;
  projectTypeList.value[3].imgs[0].url = web_gif;
})

onUnmounted(() => {
  // window.removeEventListener('scroll', scrollEvent, false)
  clearInterval(timer)
  window.scrollTo(0, 0)
})

watch(viewTime, (newState) => {
  const metaverseLine: any = document.querySelectorAll('.metaverse-line>div');
  metaverseLine.forEach((ele: any) => {
    ele.style.width = 0
  })
  metaverseLine[activeFusionIndex.value].style.width = 300 / fusionVideo.value[activeFusionIndex.value] * newState + 'rem'
})

watch(activeFusionIndex, async (newState) => {
  const windowVideo: any = document.querySelectorAll('.fusion-window>img');
  windowVideo[newState].currentTime = 0;
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: loadUrl.value.home_banner_mp4
      }, null, 8, _hoisted_2),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "video-text" }, [
        _createElementVNode("div", { class: "link-room" }, "打开「眼界」链接全新数字空间")
      ], -1)),
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "video-mask" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", null, [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "core-title" }, "混空Studio核心优势", -1)),
        _cache[14] || (_cache[14] = _createElementVNode("div", null, "构建 “工具链 + 智能体” 生态,定义元宇宙创作新范式", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (showStudioVideoPlay.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _imports_0,
                  onClick: playStudioVideoPlay
                }))
              : _createCommentVNode("", true),
            _createElementVNode("video", {
              src: loadUrl.value.studio_mp4,
              loop: "",
              muted: "",
              autoplay: "",
              onPlaying: playEvent,
              poster: _imports_1,
              playsinline: "",
              "webkit-playsinline": ""
            }, null, 40, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "title" }, "成本低", -1)),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(costList, (item, index) => {
                return _createElementVNode("div", { key: index }, [
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (e, i) => {
                      return (_openBlock(), _createElementBlock("div", { key: i }, _toDisplayString(e), 1))
                    }), 128))
                  ])
                ])
              }), 64))
            ])
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "high-precision" }, [
            _createElementVNode("div", { class: "title" }, "高精度"),
            _createElementVNode("div", { class: "precision-text" }, [
              _createElementVNode("div", null, "自研高精度空间定位算法"),
              _createElementVNode("div", null, "厘米级视觉定位"),
              _createElementVNode("div", null, "空间导航精准"),
              _createElementVNode("div", null, "支持大空间定位")
            ]),
            _createElementVNode("div", { class: "high-precision-image" })
          ], -1)),
          _createElementVNode("div", _hoisted_9, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "title" }, "易操作", -1)),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("img", {
                src: loadUrl.value.ycaozuo_gif
              }, null, 8, _hoisted_11)
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("div", null, [
              _createElementVNode("div", null, "自研混空Studio编辑工具"),
              _createElementVNode("div", null, "3D场景地图，可视化交互“拖拉拽”操作"),
              _createElementVNode("div", null, "所“建”即所得")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "title" }, "部署快", -1)),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(arrangeList, (item) => {
                return _createElementVNode("div", { key: item }, [
                  _createElementVNode("img", { src: item }, null, 8, _hoisted_14)
                ])
              }), 64))
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("div", null, [
              _createElementVNode("div", null, "仅需四步，快速部署"),
              _createElementVNode("div", null, "支持快速导入模型、音效和互动元素"),
              _createElementVNode("div", null, "无需安装，在网页端即可完成空间创作")
            ], -1))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "fusion-title" }, "数实融合 虚实互生", -1)),
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "fusion-tips" }, "共同推动产业创新融合发展", -1)),
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(metaversePlatformList.value, (item, index) => {
            return _withDirectives((_openBlock(), _createElementBlock("img", {
              src: item.url,
              key: index,
              style: _normalizeStyle({ opacity: activeFusionIndex.value == index ? 1 : 0 })
            }, null, 12, _hoisted_18)), [
              [_vShow, item.url]
            ])
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(metaversePlatformList.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.type,
                class: _normalizeClass(activeFusionIndex.value == index ? 'active' : ''),
                onClick: ($event: any) => {activeFusionIndex.value = index; viewTime.value = 1}
              }, [
                _createElementVNode("div", _hoisted_22, _toDisplayString(item.title), 1),
                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "metaverse-line" }, [
                  _createElementVNode("div")
                ], -1)),
                _createElementVNode("div", _hoisted_23, _toDisplayString(item.content), 1)
              ], 10, _hoisted_21))
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "show-project-title" }, "跨设备部署全场景展示每个项目", -1)),
      _cache[19] || (_cache[19] = _createElementVNode("div", { class: "show-project-tips" }, "文娱景区、剧场演绎、博物馆/文化馆、IP展览、商场、", -1)),
      _cache[20] || (_cache[20] = _createElementVNode("div", { class: "show-project-tips" }, "企业展厅、大型活动、品牌营销互动、广告策划、", -1)),
      _cache[21] || (_cache[21] = _createElementVNode("div", { class: "show-project-tips" }, "空间设计、教育培训、工业培训等", -1)),
      _createVNode(BannerView, { "banner-data": projectTypeList.value }, null, 8, ["banner-data"])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/counselling')))
      })
    ]),
    _createElementVNode("div", _hoisted_26, [
      _cache[23] || (_cache[23] = _createElementVNode("img", { src: _imports_2 }, null, -1)),
      _createElementVNode("div", _hoisted_27, [
        _cache[22] || (_cache[22] = _createElementVNode("div", { class: "title" }, "成功提交信息，可享专业客服一对一支持", -1)),
        _createElementVNode("div", _hoisted_28, [
          _createVNode(_component_el_input, {
            class: _normalizeClass(["form-input", checkEmpty.value.companyName ? 'error-cn' : '']),
            modelValue: contactInfo.companyName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((contactInfo.companyName) = $event)),
            placeholder: "公司名称"
          }, null, 8, ["class", "modelValue"]),
          _createVNode(_component_el_input, {
            class: _normalizeClass(["form-input", checkEmpty.value.name ? 'error-n' : '']),
            modelValue: contactInfo.name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((contactInfo.name) = $event)),
            placeholder: "姓名"
          }, null, 8, ["class", "modelValue"]),
          _createVNode(_component_el_input, {
            class: _normalizeClass(["form-input", showError.value || checkEmpty.value.phone ? 'error-text' : '']),
            modelValue: contactInfo.phone,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((contactInfo.phone) = $event)),
            placeholder: "电话"
          }, null, 8, ["class", "modelValue"]),
          _createVNode(_component_el_select, {
            placeholder: "所属行业",
            class: _normalizeClass([checkEmpty.value.industry ? 'error-i' : '', "select-default"]),
            modelValue: contactInfo.industry,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((contactInfo.industry) = $event)),
            "popper-class": "select-option"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(industryList, (item, index) => {
                return _createVNode(_component_el_option, {
                  key: index,
                  label: item.name,
                  value: item.value
                }, null, 8, ["label", "value"])
              }), 64))
            ]),
            _: 1
          }, 8, ["class", "modelValue"])
        ]),
        _createElementVNode("div", {
          class: "submit-btn",
          onClick: submitEvent
        }, "提交信息")
      ])
    ])
  ]))
}
}

})